__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['arcade-page-wrapper'].baseUrl;
import ModuleContainer from './components/ArcadePageWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/data-manager-utils': '^0.4.3',
      '@americanexpress/react-ddl': '^0.3.7',
      'react-intl': '^6.6.2'
    }
  });
}